/**
 * The qualifier a business case carries beside its type — the DSFinV-K `GV_NAME` of the row. Mirrors
 * `Shared.Core/Enums/Booking/ObjectDescription.cs`: append-only, never renumbered (the integer is the wire value
 * and sits in every stored row). A Geldtransit's qualifier follows its direction (#820, `GeldtransitPolicy`):
 * `Skimming` („Abschöpfung") out of the drawer, `Deposit` („Einlage") into it.
 */
export enum ObjectDescription {
  None,
  InitialBalance,
  Skimming,
  Deposit,
}
